import { render, staticRenderFns } from "./MapChina.vue?vue&type=template&id=7d311472&"
import script from "./MapChina.vue?vue&type=script&lang=js&"
export * from "./MapChina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports